import React from 'react'
import logo from "../components/images/logo.png";
import { useState } from "react";
import { NavLink } from "react-router-dom";

export default function LoginSignup() {
    const [action, setAction] = useState("Sign Up");
  return (
    <div className='zaidoc_login_outer'>
        <div className='header_outer'>
            <div className='container'>
                <div className='header_inner'>
                    <div className="logo"><img src={logo}/></div>
                    <div className='login_signup_button'>
                        <button type='submit' className={action==="Sign Up"?"submit active_btn":"submit"} onClick={()=>{setAction("Sign Up")}}>Sign Up</button>
                        <button type='submit'className={action==="Login"?"submit active_btn":"submit"} onClick={()=>{setAction("Login")}}>Login</button>
                    </div>
                </div>
            </div>
        </div>

        <h3>{action}</h3>
        <div className='form_outer'>
            {action==="Login"? <></>:<div className='form_input'>
                <input type='text' placeholder='Full Name'/>
                <i className="material-icons">person</i>
            </div>}
            
            <div className='form_input'>
                <input type='email' placeholder='Email'/>
                <i className="material-icons">email</i>
            </div>
            <div className='form_input'>
                <input type='password' placeholder='Password'/>
                <i className="material-icons">key</i>
            </div>
            {action==="Sign Up"? <></>:
            <div className='form_input forgot_pass'>
                <a href='/'>Forgot Password ?</a>
            </div>
            }
            {action==="Login"? <></>:
            <div className='form_input'>
            <select name="country" id="country">
                <option value="volvo">Residence Of Country</option>
                <option value="volvo">India</option>
                <option value="saab">Pakistan</option>
                <option value="mercedes">USA</option>
                <option value="audi">Austrailia</option>
            </select>
            <i className="material-icons">keyboard_arrow_down</i>
        </div>}
            
        {action==="Login"? <></>:<div className='form_input_check'>
                <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/> I certify that I am 18 years of age or older, and agree to the User Agreement and Privacy Policy
            </div>
        }

        <div className='form_buttons'>
        {action==="Login"? <></>:
            <NavLink to='/Dashboard'><button type='submit'>Create An Account</button></NavLink>
        }

        {action==="Sign Up"? <></>:
            <NavLink to='/Dashboard'><button type='submit'>Login To Dashboard</button></NavLink>
        }
        </div>
            
            
            
            
        </div>
    </div>
  )
}
